export const typeColors = {
  fire: '#FF5733',
  grass: '#66CC66',
  water: '#3399FF',
  lightning: '#FFCC33',
  psychic: '#F95587',
  fighting: '#C22E28',
  darkness: '#705746',
  metal: '#B7B7CE',
  fairy: '#E69EAC',
  dragon: '#6F35FC',
};
